import { ProductEnum } from '@/api';

import { MealPeriod } from './types';
import type { BadgeVariant, BadgeVariantKey, ProductType } from './types';
import dayjs from 'dayjs';

export const MEAL_PERIOD_LABELS: Record<MealPeriod, string> = {
  [MealPeriod.BREAKFAST]: 'Breakfast',
  [MealPeriod.LUNCH]: 'Lunch',
  [MealPeriod.DINNER]: 'Dinner',
};

export const MEAL_PERIODS: MealPeriod[] = [
  MealPeriod.BREAKFAST,
  MealPeriod.LUNCH,
  MealPeriod.DINNER,
];

export const PRODUCT_LABELS: Record<ProductType, string> = {
  [ProductEnum.POPUP]: 'Popup',
  [ProductEnum.DELIVERY]: 'Delivery',
};

export const BADGE_VARIANTS: Record<BadgeVariantKey, BadgeVariant> = {
  ACTION_REQUIRED: {
    backgroundColor: 'yellow.0',
    color: 'yellow.8',
    getText: (data) =>
      `Confirm availability \u00b7 Due ${dayjs(data.deadlineDate).format('MMM D')}`,
  },
  SUBMITTED: {
    backgroundColor: 'teal.0',
    color: 'teal',
    getText: () => 'Availability submitted',
    extraText: true,
  },
  NO_SUBMISSION_REQUIRED: {
    backgroundColor: 'teal.0',
    color: 'teal',
    getText: () => 'Current availability applies',
  },
  UPDATED: {
    backgroundColor: 'teal.0',
    color: 'teal',
    getText: () => 'Availability updated',
    extraText: true,
  },
  NOT_SUBMITTED_LOCKED: {
    backgroundColor: 'red.0',
    color: 'red',
    getText: () => 'Availability not submitted',
  },
};
